import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  ControlLabel,
  Input,
  SelectPicker,
} from 'rsuite'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
import EditButton from '../../components/buttons/editButton/EditButton'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import { useForm, Controller } from 'react-hook-form'

export default function ManageBankAccountForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  rowData,
  isAddBankAccount,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [formSchema, setFormSchema] = useState(schema)

  useEffect(() => {
    if (rowData && !isAddBankAccount) {
      // console.log('rowData', rowData.accountNo)

      setValue(formSchema.bankName.name, rowData.bankCode)
      setValue(formSchema.accountName.name, rowData.accountName)
      setValue(formSchema.bankBranch.name, rowData.bankBranch)
      setValue(formSchema.accountNo.name, rowData.accountNo)
      setValue(formSchema.accountType.name, rowData.accountTypeCode)
      clearErrors()
    } else {
      setValue(formSchema.bankName.name, '')
      setValue(formSchema.accountName.name, '')
      setValue(formSchema.bankBranch.name, '')
      setValue(formSchema.accountNo.name, '')
      setValue(formSchema.accountType.name, '')
    }
  }, [rowData])

  return (
    <>
      <Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.bankName.validators, formSchema.bankName.label)}
            </ControlLabel>

            <ErrorMessage error={errors[formSchema.bankName.name]} />
            <Controller
              name={formSchema.bankName.name}
              control={control}
              defaultValue={formSchema.bankName.value}
              rules={isValidators(formSchema.bankName.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.bankName.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={true}
                    placeholder={'เลือก' + formSchema.bankName.label}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>

          <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}></Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.accountName.validators, formSchema.accountName.label)}
            </ControlLabel>

            <ErrorMessage error={errors[formSchema.accountName.name]} />
            <Input
              name={formSchema.accountName.name}
              defaultValue={formSchema.accountName.value}
              inputRef={register(isValidators(formSchema.accountName.validators))}
              placeholder={'ระบุ' + formSchema.accountName.label}
              disabled={formSchema.accountName.disabled}
            />
          </Col>

          <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.bankBranch.validators, formSchema.bankBranch.label)}
            </ControlLabel>

            <ErrorMessage error={errors[formSchema.bankBranch.name]} />
            <Input
              name={formSchema.bankBranch.name}
              defaultValue={formSchema.bankBranch.value}
              inputRef={register(isValidators(formSchema.bankBranch.validators))}
              placeholder={'ระบุ' + formSchema.bankBranch.label}
              disabled={formSchema.bankBranch.disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.accountNo.validators, formSchema.accountNo.label)}
            </ControlLabel>

            <ErrorMessage error={errors[formSchema.accountNo.name]} />
            {/* <Input
              name={formSchema.accountNo.name}
              defaultValue={formSchema.accountNo.value}
              inputRef={register(isValidators(formSchema.accountNo.validators))}
              placeholder={'ระบุ' + formSchema.accountNo.label}
              disabled={formSchema.accountNo.disabled}
            /> */}
            <Controller
              name={formSchema.accountNo.name}
              control={control}
              defaultValue={formSchema.accountNo.value}
              rules={isValidators(formSchema.accountNo.validators)}
              render={(props) => {
                return (
                  <Input
                    placeholder={formSchema.accountNo.label}
                    value={props.value}
                    maxLength={getMaxLengthData(formSchema.accountNo.validators).value}
                    onChange={(value, e) => {
                      console.log('value', value)
                      if (isNaN(value)) {
                        return
                      }
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: 10 }}>
            <ControlLabel>
              {requiredFiled(formSchema.accountType.validators, formSchema.accountType.label)}
            </ControlLabel>

            <ErrorMessage error={errors[formSchema.accountType.name]} />
            <Controller
              name={formSchema.accountType.name}
              control={control}
              defaultValue={formSchema.accountType.value}
              rules={isValidators(formSchema.accountType.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.accountType.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'เลือก' + formSchema.accountType.label}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      </Row>
    </>
  )
}
